import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api_url: '/api/',
    showLoader: false,
  },
  mutations: {
    setShowLoader(state, {newResult}) {
      state.showLoader = newResult;
    },
  },
  actions: {

  }
})
